import {
	calculateEntryPrice,
	calculateVAT,
	exponentialBackoff,
	formatCurrency,
	getSymbol,
	sleep,
} from "@bidbattles/bloks/lib/utils";

export {
	getSymbol,
	formatCurrency,
	calculateVAT,
	calculateEntryPrice,
	exponentialBackoff,
	sleep,
};

export type FilterByPrefix<Keys extends string[], Prefix extends string> = {
	[K in Keys[number]]: K extends `${Prefix}${string}` ? K : never;
}[Keys[number]];

export function filterKeysByPrefix<
	Keys extends string[],
	Prefix extends string = string,
>(keys: Keys, prefix: Prefix): FilterByPrefix<Keys, Prefix>[] {
	return keys.filter((k) => k.startsWith(prefix)) as FilterByPrefix<
		Keys,
		Prefix
	>[];
}

export function typedObjectKeys<Object extends object>(
	obj: Object,
): Array<keyof Object> {
	return Object.keys(obj) as Array<keyof Object>;
}
